import { render } from "./viewedPage.vue?vue&type=template&id=b447a63e"
import script from "./viewedPage.vue?vue&type=script&lang=js"
export * from "./viewedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__